module.exports = __webpack_public_path__ + "assets/40e8b79b0e0217fff856ed0b78a36958.mp3";